export function getHomeRoute() {
    return '/'
}

export function getNodesRoute() {
    return '/nodes';
}
